<template>
  <div>
    <vxe-grid
      ref="itemTable"
      auto-resize
      highlight-hover-row
      size="mini"
      :data="tableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="333"
      border
      :edit-rules="validRules"
      @edit-closed="subTotAmount"
    >
      <template v-slot:top>
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ $l('order_expense_item') || '费用填报明细' }}
          </span>
          <el-divider direction="vertical" v-if="!disabled"></el-divider>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-success"
            @click="addNewsRow()"
            v-if="!disabled"
            ><i class="el-icon-plus" />{{ $l('btn_add') || '新增' }}
          </b-button>
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-danger"
            v-if="!disabled"
            @click="removeRow()"
            ><i class="el-icon-delete" />{{ $l('btn_delete') || '删除' }}
          </b-button>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_delete') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:expense="{ row }">
        <expense-select
          v-model="row.expenseCode"
          filterable
          clearable
          :body="{ expenseBizType: 'A' }"
          @change="
            (value, item) => expenseChange({ val: { value, item }, row })
          "
          :placeholder="$l('tips_select_expenseName') || '请选择费用项目'"
          size="mini"
        />
      </template>
      <template v-slot:originalExpenseType="{ row }">
        <dict-select
          v-model="row.originalExpenseType"
          :disabled="substituteInvoice === '1' || !substituteInvoice"
          :selectedLabel.sync="row.v_originalExpenseType"
          url="/master/common/dict/biz"
          :body="{ dictType: 'expenseType' }"
          filterable
          clearable
          size="mini"
          :placeholder="
            $l('tips_select_originalExpenseType') || '请选择原始费用项目'
          "
        ></dict-select>
      </template>
      <template v-slot:customer="{ row, $rowIndex }">
        <dict-select
          size="mini"
          v-model="row.custCode"
          :selectedLabel.sync="row.custName"
          url="/master/common/dict/customerSelect"
          filterable
          clearable
          :placeholder="$l('form_placeholder_custName') || '请选择费用客户'"
          @change="customerChange({ rowIndex: $rowIndex })"
        ></dict-select>
      </template>
      <template v-slot:custOrderNo="{ row }">
        <OrderSelect
          :orderCode.sync="row.orderCode"
          :custOrderNo.sync="row.custOrderNo"
          :custCode="row.custCode"
          size="mini"
          :placeholder="$l('tips_select_custOrderNo') || '请选择客户订单号'"
        />
      </template>
      <!-- TODO -->
      <template v-slot:depedit="{ row, $rowIndex }">
        <CustomerCostSector
          :ref="`costSector${$rowIndex}`"
          :depCode.sync="row.depCode"
          :displayDepCode.sync="row.displayDepCode"
          :orgDepFullName.sync="row.orgDepFullName"
          :custCode="row.custCode"
          :userCode="salesPersonCode"
          :placeholder="$l('tips_select_orgDepFullName') || '请选择分摊部门...'"
          size="mini"
        />
      </template>
      <template v-slot:depview="{ row, $rowIndex }">
        <CustomerCostSector
          :ref="`costSector${$rowIndex}`"
          :depCode.sync="row.depCode"
          :displayDepCode.sync="row.displayDepCode"
          :orgDepFullName.sync="row.orgDepFullName"
          :custCode="row.custCode"
          :userCode="salesPersonCode"
          :placeholder="$l('tips_select_orgDepFullName') || '请选择分摊部门...'"
          size="mini"
          readonly
        />
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import OrderSelect from '@/views/digital/components/order-select'
import tableColumns from './table-columns'
import { add } from '@/libs/util.number.js'
import CustomerCostSector from '@/views/digital/components/customer-cost-sector'
export default {
  components: { OrderSelect, CustomerCostSector },
  props: {
    disabled: { type: Boolean, default: false },
    userReimbursementCode: { type: String, default: '' },
    substituteInvoice: { type: String, default: '1' },
    salesPersonCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    validRules() {
      return {
        startDate: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('tips_select_startDate') || '请选择开始日期...',
          },
        ],
        endDate: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('tips_select_endDate') || '请选择结束日期...',
          },
        ],
        expenseName: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('tips_select_expenseName') || '请选择费用项目...',
          },
        ],
        v_originalExpenseType: [
          {
            required: this.substituteInvoice == '0',
            trigger: 'change',
            message:
              this.$l('tips_select_originalExpenseType') ||
              '请选择原始费用项目...',
          },
        ],
        currencyAmount: [
          {
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_currency_amount_must_be_greater_than_0') ||
              '费用金额须大于0',
          },
        ],
        billCount: [
          {
            required: true,
            trigger: 'blur',
            pattern: /([0-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_billCount_must_be_greater_than_0') ||
              '单据张数须大于0',
          },
        ],
        custName: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('form_placeholder_custName') || '请选择费用客户',
          },
        ],
        orgDepFullName: [
          {
            required: true,
            trigger: 'change',
            message:
              this.$l('tips_select_orgDepFullName') || '请选择分摊部门...',
          },
        ],
      }
    },
  },
  watch: {
    substituteInvoice: function() {
      const tmpData = this.getTableData()
      for (let i = 0; i < tmpData.length; i++) {
        if (this.substituteInvoice === '1') {
          tmpData[i].originalExpenseType = ''
          tmpData[i].v_originalExpenseType = ''
        }
      }
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      if (!this.userReimbursementCode) return
      this.$api
        .userReimbursementItemListApi({
          userReimbursementCode: this.userReimbursementCode,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    async addNewsRow() {
      const $itemTable = this.$refs.itemTable

      const { row: newRow } = await $itemTable.insertAt({}, -1)
      await $itemTable.setActiveCell(newRow, 'startDate')

      const tableData = this.getTableData()
      this.customerChange({ rowIndex: tableData.length - 1 })
    },
    async delRow(row) {
      this.$refs.itemTable.remove(row)
      this.subTotAmount()
    },
    getTableData() {
      const { fullData } = this.$refs.itemTable.getTableData()
      return fullData
    },
    async validate() {
      const result = await this.$refs.itemTable.validate(true).catch(() => true)
      return !result
    },
    async removeRow() {
      await this.$refs.itemTable.removeCheckboxRow()
      this.subTotAmount()
    },
    async subTotAmount() {
      const data = this.getTableData()
      const totAmount = data.reduce(
        (result, next) => add(result, next.currencyAmount),
        0
      )
      this.$emit('updateTotAmount', totAmount)
    },
    expenseChange({ val, row }) {
      const { item } = val || {}
      const { expenseCode, expenseName, expenseType, v_expenseType } =
        item || {}
      row.expenseCode = expenseCode
      row.expenseName = expenseName
      row.expenseType = expenseType
      row.v_expenseType = v_expenseType
    },
    customerChange({ rowIndex }) {
      const $costSector = this.$refs[`costSector${rowIndex}`]
      if (!$costSector) return
      $costSector.clear()
    },
  },
}
</script>
